var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetBudget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50065 0.708496L15.2298 4.60433V12.396L8.50065 16.2918L1.77148 12.396V4.60433L8.50065 0.708496ZM8.50065 2.34545L3.18815 5.42112V11.5792L8.50065 14.6549L13.8132 11.5792V5.42112L8.50065 2.34545ZM8.50065 11.3335C6.93584 11.3335 5.66732 10.0649 5.66732 8.50016C5.66732 6.93536 6.93584 5.66683 8.50065 5.66683C10.0654 5.66683 11.334 6.93536 11.334 8.50016C11.334 10.0649 10.0654 11.3335 8.50065 11.3335ZM8.50065 9.91683C9.28308 9.91683 9.91732 9.28259 9.91732 8.50016C9.91732 7.71774 9.28308 7.0835 8.50065 7.0835C7.71823 7.0835 7.08398 7.71774 7.08398 8.50016C7.08398 9.28259 7.71823 9.91683 8.50065 9.91683Z",
    fill: "#6F7376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetBudget);
export default __webpack_public_path__ + "static/media/set-budget.402c98655a2c4ba506d7eb75a727790b.svg";
export { ForwardRef as ReactComponent };